<div class="bw-dialog template-dialog">

  <lib-page-header
      [screenName]="data.sourceType"
      [title]="isEdit ? 'Edit template' : 'New template'"
      backTo="">
    <mat-icon icon>{{ isEdit ? 'edit' : 'link' }}</mat-icon>
    <ng-container actions>
      <button mat-icon-button (click)="cancel()" matTooltip="Close" aria-label="Close">
        <mat-icon>close</mat-icon>
      </button>
    </ng-container>
  </lib-page-header>

  <div class="bw-body">
    <form [formGroup]="form" autocomplete="off" novalidate class="form-grid">

      <mat-form-field appearance="outline">
        <mat-label>Reference path</mat-label>
        <input matInput formControlName="referencePath" placeholder="$.equipmentType" maxlength="255" required />
        <mat-icon matPrefix>arrow_outward</mat-icon>
        <mat-hint *ngIf="!isEdit">JSONPath into a row of <strong>{{ data.sourceType }}</strong> that points to the lookup key.</mat-hint>
        <mat-hint *ngIf="isEdit">Path is immutable — delete and re-create to change.</mat-hint>
        <mat-error *ngIf="form.controls['referencePath'].invalid">Reference path is required</mat-error>
      </mat-form-field>

      <div class="row two-col">
        <mat-form-field appearance="outline">
          <mat-label>Template type</mat-label>
          <input matInput formControlName="templateType" [matAutocomplete]="typeAutocomplete"
                 placeholder="EQUIPMENT_TYPE" maxlength="80" required />
          <mat-autocomplete #typeAutocomplete="matAutocomplete">
            <mat-option *ngFor="let t of filteredTypes" [value]="t">{{ t }}</mat-option>
          </mat-autocomplete>
          <mat-icon matPrefix>schema</mat-icon>
          <mat-hint *ngIf="!isEdit">Type whose rows act as templates.</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Field path</mat-label>
          <input matInput formControlName="fieldPath" placeholder="$.vendor" maxlength="255" required />
          <mat-icon matPrefix>data_object</mat-icon>
          <mat-hint *ngIf="!isEdit">JSONPath into the template row.</mat-hint>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Target path</mat-label>
        <input matInput formControlName="targetPath" placeholder="$.vendor" maxlength="255" required />
        <mat-icon matPrefix>flag</mat-icon>
        <mat-hint *ngIf="!isEdit">Where the value lands in <strong>{{ data.sourceType }}</strong> rows.</mat-hint>
        <mat-hint *ngIf="isEdit">Target path is immutable.</mat-hint>
        <mat-error *ngIf="form.controls['targetPath'].invalid">Target path is required</mat-error>
      </mat-form-field>

      <div class="toggle-row">
        <mat-slide-toggle formControlName="overwrite">Overwrite existing values</mat-slide-toggle>
        <span class="toggle-hint">Off: only fill the target when it's null. On: always replace the target.</span>
      </div>

      <mat-form-field appearance="outline">
        <mat-label>Description (optional)</mat-label>
        <textarea matInput formControlName="description" rows="2" maxlength="500"
                  placeholder="Why this template exists"></textarea>
        <mat-icon matPrefix>notes</mat-icon>
      </mat-form-field>

      <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>
    </form>
  </div>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="saving">Cancel</button>
    <button mat-flat-button color="primary" (click)="save()" [disabled]="saving || form.invalid">
      <mat-icon>save</mat-icon>
      Save
    </button>
  </mat-dialog-actions>
</div>
